/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/inviteUser.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_DISCOUNT_RECALL } from "../graphql";
import { VApplication } from "../../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { pretty } from "@vlinder-web/utils-react";

const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};


export interface IrecallDiscountMethods extends IPluginMethodMap {
  recallDiscountUser(
    args: any
  ): Promise<any>;
}

export class recallDiscountUserService implements IAgentPlugin {
  readonly methods: IrecallDiscountMethods;

  constructor() {
    this.methods = {
      recallDiscountUser:
        this.recallDiscountUser.bind(this),
    };
  }

  async recallDiscountUser(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log(args);

    try {
      if (client) {
        const res1 = await client.mutate({
          mutation: UPDATE_DISCOUNT_RECALL,
          variables:
          {
            input: {
              count: 1,
              discountId: args?.discountId,
              masqId: args?.id
            }
          }
          ,
          fetchPolicy: "no-cache",
        });
        if (res1?.data) {
          return {
            ...res1?.data?.updateDiscountStatus,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
